<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.changePassword.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.changePassword.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #changePasswordForm="ngForm" (ngSubmit)="onSubmit(changePasswordForm)">
            <h4 class="form-section"><i class="ft-cpu"></i> {{ 'account.changePassword.detailsHeader' | translate }}
            </h4>
            <div class="form-group">
              <label for="OldPassword">{{ 'account.changePassword.oldPasswordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="OldPassword" class="form-control" name="OldPassword" #OldPassword="ngModel"
                       placeholder="{{'account.changePassword.oldPasswordFieldPlaceHolder' | translate}}"
                       autocomplete="current-password"
                       [(ngModel)]="password.OldPassword" required>
              </div>
            </div>
            <div class="form-group">
              <label for="NewPassword">{{ 'account.changePassword.newPasswordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="NewPassword" class="form-control" name="NewPassword" #NewPassword="ngModel"
                       placeholder="{{'account.changePassword.newPasswordFieldPlaceHolder' | translate}}"
                       autocomplete="new-password"
                       [(ngModel)]="password.NewPassword" required minlength="8" [ngModelOptions]="{updateOn: 'blur'}"
                       pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_.,/?;:+=!*()@%&]).{8,}$"/>
              </div>
              <small class="form-text text-muted danger"
                     *ngIf="!NewPassword.valid && (NewPassword.dirty || NewPassword.touched)">
                {{ 'account.changePassword.newPasswordInformationText' | translate }}
              </small>
            </div>
            <div class="form-group">
              <label for="ConfirmPassword">{{ 'account.changePassword.confirmPasswordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="ConfirmPassword" class="form-control" name="ConfirmPassword" #ConfirmPassword="ngModel"
                       placeholder="{{'account.changePassword.confirmPasswordFieldPlaceHolder' | translate}}"
                       autocomplete="new-password"
                       [(ngModel)]="password.ConfirmPassword" required minlength="8"/>
              </div>
              <small class="form-text text-muted danger"
                     *ngIf="(ConfirmPassword.dirty || ConfirmPassword.touched) && (password.NewPassword != password.ConfirmPassword)">
                {{ 'account.changePassword.confirmPasswordInformationText' | translate }}
              </small>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1" [disabled]="!changePasswordForm.valid">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
